import type { Routes } from '@angular/router';
import {
  CONFIGURATOR_NOT_FOUND,
  CONFIGURATOR_STREAM,
  LOGIN,
  METABOX_VIEWER,
  NOT_FOUND,
  PASSWORD,
  ROOT,
} from '@shared/constants/routing-paths.constants';
import { AuthGuard } from '@shared/guards/auth.guard';
import {
  BASIC_CONFIGURATOR_PATH,
  MODULAR_CONFIGURATOR_PATH,
} from '@features/configurator-manager/shared/constants/configurators.paths';
import { NoAuthGuard } from '@shared/guards/no-auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: `${CONFIGURATOR_STREAM}/${BASIC_CONFIGURATOR_PATH}`,
    loadChildren: () =>
      import(
        '@features/configurator-stream/basic/constants/basic-configurator-stream.routes'
      ).then((mod) => mod.BasicConfiguratorStreamRoutes),
    title: 'Basic Configurator Stream',
  },
  {
    path: `${CONFIGURATOR_STREAM}/${MODULAR_CONFIGURATOR_PATH}`,
    loadChildren: () =>
      import(
        '@features/configurator-stream/modular/constants/modular-configurator-stream.routes'
      ).then((mod) => mod.ModularConfiguratorStreamRoutes),
    title: 'Modular Configurator Stream',
  },
  {
    path: `${CONFIGURATOR_NOT_FOUND}`,
    loadComponent: () =>
      import(
        '@features/configurator-stream/shared/components/not-found/not-found.component'
      ).then((mod) => mod.NotFoundComponent),
    title: 'Configurator Not Found',
  },
  // Important Redirects not delete for backwards compatibility
  {
    path: `embedvph/universal-configurator`,
    redirectTo: CONFIGURATOR_STREAM,
  },
  {
    path: `embedvph/${CONFIGURATOR_STREAM}`,
    redirectTo: CONFIGURATOR_STREAM,
  },
  {
    path: `${CONFIGURATOR_STREAM}`,
    redirectTo: `${CONFIGURATOR_STREAM}/${BASIC_CONFIGURATOR_PATH}`,
  },
  {
    path: METABOX_VIEWER,
    loadChildren: () =>
      import('@features/metabox-viewer/constants/metabox-viewer.routes').then(
        (mod) => mod.MetaboxViewerRoutes,
      ),
    title: 'Stream Viewer',
  },
  {
    path: LOGIN,
    loadComponent: () =>
      import('@features/sign-in/layout/signin.component').then(
        (mod) => mod.SigninComponent,
      ),
    title: '3D Source Metabox',
    canActivate: [NoAuthGuard],
  },
  {
    path: PASSWORD,
    loadComponent: () =>
      import(
        '@features/account/components/renew-password/renew-password.component'
      ).then((mod) => mod.RenewPasswordComponent),
    title: 'Renew Password',
    canActivate: [NoAuthGuard],
  },
  {
    path: NOT_FOUND,
    loadComponent: () =>
      import('@features/not-found/not-found.component').then(
        (mod) => mod.NotFoundComponent,
      ),
    title: 'Not Found',
  },
  {
    path: ROOT,
    loadChildren: () =>
      import('@features/layout/constants/layout.routes').then(
        (mod) => mod.LayoutRoutes,
      ),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: NOT_FOUND },
];
